export const errors = {
    "Receiver address line exceeds 40 characters.": "The street address is too long. AusPost has a 40 character limit on each line of a street address. Try splitting the address over two lines."
}